import React, { useState } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteIcon from '@material-ui/icons/Delete';
import Typography from '@material-ui/core/Typography';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Box from '@material-ui/core/Box';
import { IconButton } from '@material-ui/core';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import Divider from '@material-ui/core/Divider';
import clsx from 'clsx';
import useStyles from './printStyles';


const Layers = ({
  tool, // eslint-disable-line no-unused-vars
  items,
  text, // eslint-disable-line no-unused-vars
  images,
  setText,
  defaultText,
  selectedLayer,
  setImageAction,
  setOpen,
  setShowTextForm,
  setSelectedLayer,
  handleLayerSelect,
  handleItemVisibility,
  handleDeleteLayer,
  handleDragStart,
  handleDragOver,
  handleDragEnd
}) => {

  const [anchorEl, setAnchorEl] = useState();
  const classes = useStyles();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (action, event) => { // eslint-disable-line no-unused-vars
    setAnchorEl(null);
    if (action) {
      setImageAction(action);
      setOpen(true);
    }
  };

  return (
    <>
      <Box mx={4} py={2}>
        <Box display="flex" alignItems="center">
          <Typography variant="h6">Layers</Typography>
          <Box display="flex" flexGrow={1} justifyContent="flex-end">
            <IconButton
              aria-controls="add-layer-menu"
              aria-haspopup="true"
              onClick={(event) => {
                handleClick(event);
              }}>
              <PlaylistAddIcon />
            </IconButton>
          </Box>
        </Box>
        <List className="dropzone">
          {items.map((element, index) => (
            <ListItem
              key={index}
              data-id={element.name}
              className={clsx({ draggable: true, selectedLayer: element.name == selectedLayer })}
              draggable="true"
              onDragStart={handleDragStart}
              onDragOver={handleDragOver}
              onDragEnd={handleDragEnd}
              onClick={() => handleLayerSelect(element.name)}>
              <ListItemIcon>
                <VisibilityIcon
                  className={clsx({ layerVisibility: true, hidden: element.hidden})}
                  onClick={handleItemVisibility} />
              </ListItemIcon>
              <img className={classes.imagePreview} src={
                element.type == 'image'
                  ? images[element.name]?.image
                  : ''} />
              <ListItemText primary={element.name} />
              <ListItemIcon>
                <DeleteIcon
                  className={clsx({ delete: true })}
                  onClick={handleDeleteLayer} />
              </ListItemIcon>
            </ListItem>
          ))}
        </List>
        <Box ml={1}>
        </Box>
        <Menu
          id="add-layer-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={() => handleClose()}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <MenuItem onClick={() => handleClose('import')}>Import Image(s)</MenuItem>
          <Divider />
          <MenuItem disabled onClick={() => handleClose('import')}>Upload Image(s)</MenuItem>
          <Divider />
          <MenuItem onClick={() => {
            setShowTextForm(true);
            setSelectedLayer();
            setText(defaultText);
            handleClose();
          }}>Add Text</MenuItem>
        </Menu>
      </Box>
    </>
  );
};


export default Layers;
